import { Injectable } from "@angular/core";
import { environment } from "@app/../environments/environment";
import { TimerInterval } from "@shared/clickar-constants";
import { Subject } from "rxjs";

export interface SpinnerState {
	show: boolean;
}

@Injectable()
export class SpinnerService {
	private static timeout: number;
	private static counter = 0;
	private spinnerSubject = new Subject<SpinnerState>();
	spinnerState = this.spinnerSubject.asObservable();

	show(what: string) {
		SpinnerService.counter++;
		if (!environment.production) {
			console.log(`${new Date()} - Show spinner: ${what} - count: ${SpinnerService.counter}`);
		}
		if (SpinnerService.counter === 1) {
			this.spinnerSubject.next(<SpinnerState>{ show: true });
		}
		this.resetTimeout();
	}

	hide(what: string, force?: boolean) {
		SpinnerService.counter = force
			? 0
			: Math.max(--SpinnerService.counter, 0);
		if (!environment.production) {
			console.log(`${new Date()} - Hide spinner: ${what} - count: ${SpinnerService.counter}`);
		}
		if (SpinnerService.counter === 0) {
			this.spinnerSubject.next(<SpinnerState>{ show: false });
		}
		this.resetTimeout();
	}

	resetTimeout(): void {
		if (SpinnerService.timeout) {
			clearTimeout(SpinnerService.timeout);
		}
		// Timeout helps to avoid infinite spinner
		SpinnerService.timeout = window.setTimeout(() => {
			if (SpinnerService.counter) {
				if (!environment.production) {
					console.log(`${new Date()} - Force hiding spinner; suspended calls ${SpinnerService.counter}`);
				}
				SpinnerService.counter = 0;
				this.spinnerSubject.next(<SpinnerState>{ show: false });
			}
		}, TimerInterval.SPINNER_FORCE_HIDING);
	}
}
